import React, { useEffect, useState } from "react";
// import { Controller } from "react-hook-form";
import DynamicFieldsGrid from "./DynamicFieldsGrid";
import ControlledField from "./ControlledField";
import { formatCurrency } from "../../../../utils/format";

// Render loans rows dynamically using DynamicFieldsGrid

export default function LoansToBePaid({
  control,
  FloatingInput,
  getValues,
  cleanNumber,
  handleCurrencyBlur,
  onFormatted,
}) {
  // We'll compute totals on blur instead of on every keystroke. Use local state to store the computed total.
  const [loansTotalSum, setLoansTotalSum] = useState(0);

  // read totals from parent formData only as a fallback ,
  // but prefer the live watched sum when available.
  const loansTotalRaw =
    (getValues
      ? getValues("loansToBePaid_total") ?? getValues("loansToBePaidTotal")
      : undefined) ?? 0;
  const loansTotal =
    Number(String(loansTotalRaw).replace(/[^0-9.-]+/g, "")) || 0;

  const parseNum = (v) =>
    Number(String(v ?? "").replace(/[^0-9.-]+/g, "")) || 0;

  const computeLoansTotalFromForm = () => {
    try {
      const b1 = getValues
        ? getValues("loanInfoMeta.loansToBePaidBalance1")
        : 0;
      const b2 = getValues
        ? getValues("loanInfoMeta.loansToBePaidBalance2")
        : 0;
      const b3 = getValues
        ? getValues("loanInfoMeta.loansToBePaidBalance3")
        : 0;
      const sum = parseNum(b1) + parseNum(b2) + parseNum(b3);
      setLoansTotalSum(sum);
      return sum;
    } catch (e) {
      return 0;
    }
  };

  useEffect(() => {
    // initialize total from existing form values
    const initial = computeLoansTotalFromForm();
    // if parent provided a fallback loansTotal, use it when initial is zero
    if (!initial && loansTotal) setLoansTotalSum(loansTotal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fields = [
    {
      key: "existing1st",
      label: "Existing 1st",
      className: "input-filled",
      /* value:
        (getValues ? getValues("loanInfoMeta.loansToBePaidBalance1") : "") ??
        "",
      rate: (getValues ? getValues("loanInfoMeta.loansToBePaidRate1") : "") ?? "", */
      balanceName: "loanInfoMeta.loansToBePaidBalance1",
      rateName: "loanInfoMeta.loansToBePaidRate1",
    },
    {
      key: "existing2nd",
      label: "Existing 2nd",
      className: "",
      /* value:
        (getValues ? getValues("loanInfoMeta.loansToBePaidBalance2") : "") ??
        "",
      rate: (getValues ? getValues("loanInfoMeta.loansToBePaidRate2") : "") ?? "", */
      balanceName: "loanInfoMeta.loansToBePaidBalance2",
      rateName: "loanInfoMeta.loansToBePaidRate2",
    },
    {
      key: "existing3rd",
      label: "Existing 3rd",
      className: "",
      /* value:
        (getValues ? getValues("loanInfoMeta.loansToBePaidBalance3") : "") ??
        "",
      rate: (getValues ? getValues("loanInfoMeta.loansToBePaidRate3") : "") ?? "", */
      balanceName: "loanInfoMeta.loansToBePaidBalance3",
      rateName: "loanInfoMeta.loansToBePaidRate3",
    },
  ];

  const renderLoanItem = (
    item,
    { control, FloatingInput, cleanNumber, toBaseKey }
  ) => {
    const balanceName =
      item.balanceName ||
      toBaseKey(item.camelKey || item.key || item.label || "") + "Balance";
    const rateName =
      item.rateName ||
      toBaseKey(item.camelKey || item.key || item.label || "") + "Rate";

    return (
      <>
        <div
          className="calc-frm-fld form-group sign-of-amount"
          key={balanceName}
        >
          <ControlledField
            name={balanceName}
            control={control}
            className={item.className}
            InputComponent={FloatingInput}
            defaultValue={item.value ?? ""}
            placeholder=""
            label={item.label}
            type="text"
            cleanNumber={cleanNumber}
            handleCurrencyBlur={handleCurrencyBlur}
            onFormatted={(fieldName, formatted) => {
              // recompute total on blur
              // bubble up so parent (ManualSheetSection) can set RHF value, sync parent state and trigger calculations
              onFormatted && onFormatted(fieldName, formatted);
              computeLoansTotalFromForm();
            }}
          />
        </div>

        <div
          className="calc-frm-fld form-group sign-of-percentage"
          key={rateName}
        >
          <ControlledField
            name={rateName}
            control={control}
            className={item.className}
            InputComponent={FloatingInput}
            defaultValue={item.rate ?? ""}
            placeholder=""
            label={item.label}
            type="text"
            cleanNumber={cleanNumber}
            handleCurrencyBlur={handleCurrencyBlur}
            onFormatted={(fieldName, formatted) => {
              // rates may affect calculations elsewhere; bubble up
              onFormatted && onFormatted(fieldName, formatted);
            }}
          />
        </div>
      </>
    );
  };

  return (
    <>
      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">
          <span className="heading-c">Balance $</span>
        </div>
        <div className="calc-frm-fld form-group">
          <span className="heading-c">Rate %</span>
        </div>
      </div>

      <DynamicFieldsGrid
        fields={fields}
        control={control}
        FloatingInput={FloatingInput}
        cleanNumber={cleanNumber}
        fullRowPerItem={true}
        renderItem={renderLoanItem}
      />

      <div className="calc-frm-field">
        <div className="calc-frm-fld form-group">&nbsp;</div>
        <div className="calc-frm-fld form-group heading-c">
          Total ${" "}
          {loansTotalSum && loansTotalSum > 0
            ? `${formatCurrency(loansTotalSum)}`
            : loansTotal
            ? `${formatCurrency(loansTotal)}`
            : "0.00"}
        </div>
      </div>
    </>
  );
}
